import { render } from "./GestioneTicketAssistenza.vue?vue&type=template&id=8a162636"
import script from "./GestioneTicketAssistenza.vue?vue&type=script&lang=js"
export * from "./GestioneTicketAssistenza.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__